import { LEFT_NAV_TYPES } from '@constants/actionTypes/leftNavTypes';

export const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case LEFT_NAV_TYPES.SET_LEFT_NAV_PARAMS: {
            return action.leftNavParams;
        }
        default:
            return state;

    }
};